import "./App.css";
import Login from "./auth/Login";
import SideBar from "./components/SideBar";
import AddUser from "./pages/AddUser";
import AllUsers from "./pages/AllUsers";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AllCalls from "./pages/AllCalls";
import ShipmentDetails from "./pages/ShipmentDetails";
import CallEvolution from "./pages/CallEvolution";

import { QueryClient, QueryClientProvider } from "react-query";
import CsHome from "./pages/CsHome";
import Inquiry from "./pages/Inquiry";
import DataEntry from "./pages/DataEntry";

function App() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home-page" element={<SideBar />} />
          <Route path="/add-user" element={<AddUser />} />
          <Route path="/all-user" element={<AllUsers />} />
          <Route path="/all-calls" element={<AllCalls />} />
          <Route path="/cs-home" element={<CsHome />} />
          <Route path="/call-evolution" element={<CallEvolution />} />
          <Route path="/shipment-details" element={<ShipmentDetails />} />
          <Route path="/general-inquiry" element={<Inquiry />} />
          <Route path="/data-entry" element={<DataEntry />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
